<div id="loading-widget" class="overlay text-center">
<div class="loader loader-chart">
    <div class="line line1"></div>
    <div class="line line2"></div>
    <div class="line line3"></div>
  </div>
  </div>
